import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import UpdatePageTitle from '../../utils/common'
import './styles.css'
import archiveJson from '../../assets/generated/archiveList.json'

const About = () => {
  UpdatePageTitle('Archives')
  return (
    <section className={cx('section')}>
      <h1 className={cx('section-header')}>Archives</h1>
      <div className={cx('article-content')}>
        {archiveJson.archiveList.map(archiveEntry => (
          <div key={archiveEntry.year}>
            <h2>{archiveEntry.year}</h2>
            <ul className={cx('archive-list')}>
              {archiveEntry.articles.map(article => (
                <li key={article.id}>
                  <div className={cx('article-time')}>{article.date.month}</div>
                  <Link to={article.link}>
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  )
}

export default About



// WEBPACK FOOTER //
// ./src/client/containers/archives/index.js